import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarBackButtonConfig } from '../../utils/toolbar';
import { ButtonComponentConfig } from 'libs/components/src/lib/utils/button/button-component-config.interface';

@Component({
  selector: 'rappider-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class RappiderToolbarComponent {
  @Input() displayBackButton = true;
  @Input() toolbarButtons?: ButtonComponentConfig[];
  @Output() backButtonClick = new EventEmitter<string>();
  @Output() toolbarButtonClick = new EventEmitter<ButtonComponentConfig>();

  toolbarBackButtonConfig = ToolbarBackButtonConfig;

  constructor(private location: Location) { }

  onToolbarBackButtonClick() {
    this.backButtonClick.emit(new Date().toISOString());
  }

  onToolbarButtonClick(button: ButtonComponentConfig) {
    this.toolbarButtonClick.emit(button);
  }

}
